import DebugDashboard from "../../../Components/Dashboards/Default";

export default function Debug() {
    return (
        <div className='page-body'>
            <DebugDashboard/>
        </div>
    )
}